/* eslint-disable object-shorthand */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
export const setPageData = (pageData) => {
  if (typeof window === 'undefined') return;

  var settings = pageData?.settings || pageData?.config;
  var __MARKETPLACE__ = { settings: settings };
  var injectedConfiguratorSettings = pageData?.settings || pageData?.config;
  var featureGates = pageData?.featureGates;
  var thdBreadcrumbInfo = pageData?.thdBreadcrumbInfo;

  window.settings = settings;
  window.injectedConfiguratorSettings = injectedConfiguratorSettings;
  window.__MARKETPLACE__ = __MARKETPLACE__;
  window.thdBreadcrumbInfo = thdBreadcrumbInfo;
  window.thdBreadcrumbInfo = pageData?.thdBreadcrumbInfo;
  window.featureGates = featureGates;
  if (pageData?.pageMetaData?.meta?.title) document.title = pageData?.pageMetaData?.meta?.title;
};

export default setPageData;
